import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <a href="#" className="nav-logo">
          <span className="logo-icon">A</span>
          AUTO<span className="logo-accent">EXPERTS</span>
        </a>

        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li><a href="#about" onClick={closeMenu}>About</a></li>
          <li><a href="#brands" onClick={closeMenu}>Brands</a></li>
          <li><a href="#products" onClick={closeMenu}>Products</a></li>    {/* 👈 new link */}
          <li><a href="#why" onClick={closeMenu}>Why Us</a></li>
          <li><a href="#markets" onClick={closeMenu}>Markets</a></li>
          <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
          <li><a href="#contact" className="nav-cta" onClick={closeMenu}>Request Quote</a></li>
        </ul>

        <div className={`nav-hamburger ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu" role="button" tabIndex="0">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;